import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const GET_AUDIT_LIST = "GET_AUDIT_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetAuditList`,
    method: "POST",
     ...getDefaultOptions(),
    body: JSON.stringify(data)
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_LIST, service, mock);
